import { Status } from "typedef/Loan";
import BorrowerSteps from "typedef/BorrowerSteps";
import CoborrowerSteps from "typedef/CoborrowerSteps";

const getDisclosuresData = (
  step: BorrowerSteps | CoborrowerSteps | undefined
): {
  status: Status;
  message?: string;
} => {
  const initialStatus = step?.disclosuresVerification?.status ?? "pending";
  const finalStatus = step?.finalDisclosuresVerification?.status ?? "pending";
  const initialMessage = step?.disclosuresVerification?.message ?? "";

  if (initialStatus === "success" && finalStatus === "pending") {
    return {
      status: "analyzing",
      message:
        "Initial disclosures signed. Review your closing disclosures 3 business days before your closing date.",
    };
  } else {
    return {
      status: initialStatus,
      message: initialMessage,
    };
  }
};

export default getDisclosuresData;
